export const toggleSidebar = () => async dispatch => {
  dispatch({ type: 'SIDEBAR_TOGGLE' })
}
